import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetHospitalList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Hospital/GetList?` + params, null);
  
export const GetHospitalDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Hospital/GetDetail?` + params, null);

export const CreateHospital = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Hospital/Create`, data);

export const UpdateHospital = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Hospital/Update`, data);    

export const DeleteHospital = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Hospital/Delete`, data);
